import type { PricingStrategyProfileResponse } from '@/shared/api';
import {
  indexedRows,
  profileValues,
  row,
  type ProfileComparisonSection,
} from './profileComparisonModel';

export function buildTimingSections(
  profiles: PricingStrategyProfileResponse[],
): ProfileComparisonSection[] {
  return [
    {
      id: 'lastMinute',
      titleKey: 'lastMinute',
      rows: indexedRows(
        profiles,
        (p) => p.lastMinuteSteps,
        (index, items) => [
          row(
            `last-${index}-window`,
            'lastMinuteStep',
            'lastMinuteWindow',
            'text',
            items.map((value) => value?.window ?? null),
          ),
          row(
            `last-${index}-time`,
            'lastMinuteStep',
            'localTimeWindow',
            'time',
            items.map((value) =>
              value ? `${value.startLocalTime ?? ''}|${value.endLocalTime ?? ''}` : null,
            ),
          ),
          row(
            `last-${index}-release`,
            'lastMinuteStep',
            'negativeRelease',
            'percent',
            items.map((value) => value?.negativeOccupancyReleasePercent ?? null),
          ),
          row(
            `last-${index}-direct`,
            'lastMinuteStep',
            'directAdjustment',
            'percent',
            items.map((value) => value?.directAdjustmentPercent ?? null),
          ),
        ],
      ),
    },
    buildCalendarSection(profiles),
  ];
}

function buildCalendarSection(
  profiles: PricingStrategyProfileResponse[],
): ProfileComparisonSection {
  return {
    id: 'calendar',
    titleKey: 'calendarRules',
    rows: [
      ...indexedRows(
        profiles,
        (p) => p.weekdayAdjustments,
        (index, items) => [
          row(
            `weekday-${index}-band`,
            'weekdayAdjustment',
            'weekdayBand',
            'text',
            items.map((value) => value?.band ?? null),
          ),
          row(
            `weekday-${index}-value`,
            'weekdayAdjustment',
            'weekdayValue',
            'percent',
            items.map((value) => value?.adjustmentPercent ?? null),
          ),
        ],
      ),
      row(
        'holiday',
        'holidayRule',
        'holidayRule',
        'text',
        profileValues(profiles, (p) => p.holidayAdjustmentRule),
      ),
      ...indexedRows(
        profiles,
        (p) => p.farOutBands,
        (index, items) => [
          row(
            `far-${index}-range`,
            'farOutBand',
            'farOutRange',
            'text',
            items.map((value) => (value ? `${value.fromDays}–${value.toDays ?? '∞'}` : null)),
          ),
          row(
            `far-${index}-value`,
            'farOutBand',
            'farOutValue',
            'percent',
            items.map((value) => value?.adjustmentPercent ?? null),
          ),
        ],
      ),
    ],
  };
}
